module.exports = __webpack_public_path__ + "resources/img/main_banner_gov_m_01.9c2c88ec5ca812f01b485045d5f4c5e9.png";